/* ============================================================
   SINNER ARCHIVE — theme behaviour
   No dependencies. Everything degrades to a working server-
   rendered page if this file fails to load.
   ============================================================ */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* Translated copy comes from snippets/js-globals.liquid; the fallbacks
     keep the static preview (index.html) working without Liquid. */
  function str(key, fallback) {
    var s = window.SINNER && window.SINNER.strings;
    return (s && s[key]) || fallback;
  }

  /* Bind an element once. The theme editor re-runs boot() on every
     section reload, and without this listeners and timers stack up. */
  function once(el, key) {
    var flag = "sinnerBound" + key;
    if (el.dataset[flag]) return false;
    el.dataset[flag] = "1";
    return true;
  }

  function each(selector, fn, scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(selector), fn);
  }

  /* ── Money formatting ──────────────────────────────────── */
  /* Covers every placeholder Shopify allows in a store's money format,
     including the space/comma style used for PLN and most of the EU. */
  function formatMoney(cents) {
    var fmt = (window.SINNER && window.SINNER.moneyFormat) || "${{amount}}";
    var value = Number(cents) || 0;

    function group(decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split(".");
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    return fmt.replace(/<[^>]*>/g, "").replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return group(0, ",", ".");
        case "amount_with_comma_separator": return group(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(0, ".", ",");
        case "amount_with_space_separator": return group(2, " ", ",");
        case "amount_no_decimals_with_space_separator": return group(0, " ", ",");
        case "amount_with_apostrophe_separator": return group(2, "'", ".");
        default: return group(2, ",", ".");
      }
    });
  }

  /* ── Headline fit: measure, don't guess ────────────────── */
  /* The CSS min(15.2vw,196px) is the pre-JS fallback; this trims it to an
     exact edge-to-edge fit so a line never wraps and never overflows,
     whatever the device width or the font's real advance widths are.   */
  function fitHeadline(hl) {
    var lines = hl.querySelectorAll("span");
    var avail = hl.clientWidth;
    if (!lines.length || !avail) return;

    hl.style.fontSize = "100px";

    var widest = 0;
    for (var i = 0; i < lines.length; i++) {
      /* Lift max-width:100% for the measurement. Left on, it clamps the
         box to the container, so the reading can never exceed it and the
         fit always computes "already perfect" while the text silently
         overflows and gets clipped. Measuring the border box (rather than
         scrollWidth) also keeps the absolutely-positioned halo out of it,
         which would otherwise inflate the line by its overhang. */
      lines[i].style.maxWidth = "none";
      var w = lines[i].getBoundingClientRect().width;
      lines[i].style.maxWidth = "";
      if (w > widest) widest = w;
    }

    hl.style.fontSize = widest
      ? Math.min((100 * avail) / widest, 210).toFixed(2) + "px"
      : "";
  }

  function fitHeadlines() { each(".hl", fitHeadline); }

  var fitBound = false;
  function initHeadlineFit() {
    fitHeadlines();
    if (fitBound) return;
    fitBound = true;

    var raf = 0;
    function queue() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fitHeadlines);
    }
    addEventListener("resize", queue);
    addEventListener("orientationchange", queue);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeadlines);
  }

  /* ── Countdown ─────────────────────────────────────────── */
  function initCountdown() {
    each("[data-countdown]", function (clock) {
      if (!once(clock, "Clock")) return;

      var target = new Date(clock.getAttribute("data-countdown"));
      if (isNaN(target.getTime())) {
        clock.hidden = true;
        return;
      }

      var scope = clock.closest("[data-countdown-scope]") || clock.closest(".actionbox") || document;
      var note = scope.querySelector("[data-countdown-note]");
      var closedText = clock.getAttribute("data-closed-text") || "Window closed.";
      var units = {};
      each("[data-u]", function (el) { units[el.getAttribute("data-u")] = el; }, clock);

      function pad(n) { return String(n).padStart(2, "0"); }

      var started = false;
      function set(key, value) {
        var el = units[key];
        if (!el || el.textContent === value) return;
        el.textContent = value;
        if (!started || reduced) return;
        el.classList.remove("tick");
        void el.offsetWidth;
        el.classList.add("tick");
      }

      var timer = 0;
      function tick() {
        if (!document.body.contains(clock)) return clearInterval(timer);
        var left = target - Date.now();
        if (left <= 0) {
          clock.style.opacity = ".35";
          if (note) { note.textContent = closedText; note.hidden = false; }
          /* On the password page, zero means "doors open": unfold the key field */
          var gate = scope !== document && scope.querySelector(".pwgate");
          if (gate) gate.classList.add("is-open");
          Object.keys(units).forEach(function (k) { units[k].textContent = "00"; });
          clearInterval(timer);
          return;
        }
        var s = Math.floor(left / 1000);
        set("d", pad(Math.floor(s / 86400)));
        set("h", pad(Math.floor((s % 86400) / 3600)));
        set("m", pad(Math.floor((s % 3600) / 60)));
        set("s", pad(s % 60));
        started = true;
      }

      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* ── Scroll reveal ─────────────────────────────────────── */
  /* Sections fade up; photo frames open like a shutter. Whatever enters
     the viewport in the same frame is staggered top-left to bottom-right,
     so a grid of cards ripples in instead of popping at once. */
  var revealIO = null;
  function initReveal() {
    /* Prints get pasted in and develop; product frames just develop. The
       hero, manifesto and password backgrounds have their own entrance. */
    each(".snap:not(.hx__photo):not(.mani__bg):not(.pw__bg), .plate, .look__media, .card__media", function (el) {
      el.classList.add("rv-media");
    });
    var items = document.querySelectorAll(".rv:not(.in), .rv-media:not(.in), [data-fix]:not(.in)");
    if (!items.length) return;
    /* In the theme editor, show everything at once: a merchant editing a
       section below the fold must not stare at invisible content. */
    if (reduced || designMode || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add("in"); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        var batch = entries
          .filter(function (en) { return en.isIntersecting; })
          .map(function (en) { return { el: en.target, r: en.boundingClientRect }; })
          .sort(function (x, y) { return (x.r.top - y.r.top) || (x.r.left - y.r.left); });
        batch.forEach(function (item, i) {
          var el = item.el;
          el.style.setProperty("--rv-d", Math.min(i * 0.07, 0.42).toFixed(2) + "s");
          el.classList.add("in");
          revealIO.unobserve(el);
          /* Drop the delay once in, so hover transitions answer instantly */
          setTimeout(function () { el.style.removeProperty("--rv-d"); }, 1900);
        });
      }, { rootMargin: "0px 0px -6% 0px", threshold: 0.06 });
    }
    Array.prototype.forEach.call(items, function (el) { revealIO.observe(el); });
  }

  /* ── Page transitions (fallback) ───────────────────────── */
  /* Chrome, Edge and Safari 18.2+ cross-fade pages natively through
     @view-transition (see layout/theme.liquid). Other browsers get the
     same feel here: fade the page out, then follow the link. */
  var ptBound = false;
  function initPageTransitions() {
    var html = document.documentElement;
    if (ptBound || reduced || designMode) return;
    if (!html.classList.contains("pt-fallback") || !html.classList.contains("has-pt")) return;
    ptBound = true;

    document.addEventListener("click", function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest("a[href]");
      if (!a || a.hasAttribute("download") || (a.target && a.target !== "_self")) return;
      var href = a.getAttribute("href");
      if (!href || href.charAt(0) === "#" || /^(mailto|tel|javascript):/i.test(href)) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search) return;
      e.preventDefault();
      html.classList.add("is-leaving");
      setTimeout(function () { location.href = url.href; }, 300);
    });

    /* Coming back through the back button restores the page from cache —
       still faded out unless we undo it. */
    addEventListener("pageshow", function (e) {
      if (e.persisted) html.classList.remove("is-leaving");
    });
  }

  /* ── Header: glass once scrolled, tucks away going down ── */
  var hdrBound = false;
  function initHeaderScroll() {
    if (hdrBound) return;
    hdrBound = true;
    var html = document.documentElement;
    var hide = html.classList.contains("has-hide-hdr") && !designMode;
    var last = window.scrollY;
    var queued = false;

    function update() {
      queued = false;
      var y = Math.max(0, window.scrollY);
      html.classList.toggle("is-scrolled", y > 8);
      if (!hide) return;
      if (y < 140 || html.classList.contains("nav-open")) {
        html.classList.remove("hdr-hidden");
      } else if (y > last + 8) {
        html.classList.add("hdr-hidden");
      } else if (y < last - 8) {
        html.classList.remove("hdr-hidden");
      }
      if (Math.abs(y - last) > 8) last = y;
    }

    addEventListener("scroll", function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }, { passive: true });

    /* A keyboard user tabbing into the header must be able to see it */
    document.addEventListener("focusin", function (e) {
      if (e.target.closest && e.target.closest(".hdr")) html.classList.remove("hdr-hidden");
    });
    update();
  }

  /* ── Accordion: animate the height instead of snapping ── */
  // Wide tables on phones: fade the right edge until it is scrolled to the end
  function initTables() {
    document.querySelectorAll('.tablewrap').forEach(function (w) {
      function check() {
        w.classList.toggle('is-scrollable', w.scrollWidth > w.clientWidth + 2);
        w.classList.toggle('is-end', w.scrollLeft + w.clientWidth >= w.scrollWidth - 4);
      }
      w.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  }

  function initAccordions() {
    if (reduced || !Element.prototype.animate) return;
    each(".faq details", function (d) {
      var summary = d.querySelector("summary");
      if (!summary || !once(d, "Acc")) return;
      var state = d.open;
      var anim = null;

      summary.addEventListener("click", function (e) {
        e.preventDefault();
        var from = d.getBoundingClientRect().height;
        if (anim) anim.cancel();
        var opening = !state;
        state = opening;
        if (opening) d.open = true;
        var chrome = d.offsetHeight - d.clientHeight;
        var to = opening ? d.scrollHeight + chrome : summary.offsetHeight + chrome;

        d.classList.add("is-animating");
        d.classList.toggle("is-opening", opening);
        anim = d.animate(
          { height: [from + "px", to + "px"] },
          { duration: opening ? 560 : 420, easing: "cubic-bezier(.16,1,.3,1)" }
        );
        anim.onfinish = function () {
          anim = null;
          if (!state) d.open = false;
          d.classList.remove("is-animating", "is-opening");
        };
      });
    });
  }

  /* ── Stars drift against the scroll ────────────────────── */
  var drifters = [];
  var driftBound = false;
  function initParallax() {
    if (reduced) return;
    each("[data-parallax]", function (el) {
      var f = parseFloat(el.getAttribute("data-parallax"));
      if (f && once(el, "Px")) drifters.push({ el: el, f: f });
    });
    if (driftBound || !drifters.length) return;
    driftBound = true;

    var queued = false;
    function frame() {
      queued = false;
      var vh = window.innerHeight;
      drifters = drifters.filter(function (d) { return document.body.contains(d.el); });
      drifters.forEach(function (d) {
        var parent = d.el.offsetParent;
        if (!parent) return;
        /* Measure the untransformed parent, never the moving star itself */
        var c = parent.getBoundingClientRect().top + d.el.offsetTop + d.el.offsetHeight / 2;
        if (c < -300 || c > vh + 300) return;
        var py = Math.max(-36, Math.min(36, (c - vh / 2) * -d.f));
        d.el.style.setProperty("--py", py.toFixed(1) + "px");
      });
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(frame);
    }
    addEventListener("scroll", queue, { passive: true });
    addEventListener("resize", queue);
    frame();
  }

  /* ── Mobile navigation ─────────────────────────────────── */
  function initNav() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var panel = document.getElementById("mobile-nav");
    if (!toggle || !panel || !once(toggle, "Nav")) return;
    var scrim = document.querySelector("[data-nav-scrim]");

    function setOpen(open) {
      panel.classList.toggle("open", open);
      document.documentElement.classList.toggle("nav-open", open);
      if (open) document.documentElement.classList.remove("hdr-hidden");
      toggle.setAttribute("aria-expanded", String(open));
      toggle.textContent = open
        ? toggle.getAttribute("data-label-close") || "CLOSE"
        : toggle.getAttribute("data-label-open") || "MENU";
    }

    toggle.addEventListener("click", function () {
      setOpen(!panel.classList.contains("open"));
    });
    if (scrim) scrim.addEventListener("click", function () { setOpen(false); });
    panel.addEventListener("click", function (e) {
      if (e.target.closest("a")) setOpen(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && panel.classList.contains("open")) {
        setOpen(false);
        toggle.focus();
      }
    });
  }

  /* ── Quantity stepper ──────────────────────────────────── */
  function initQty() {
    each("[data-qty]", function (box) {
      var input = box.querySelector("input");
      if (!input || !once(box, "Qty")) return;
      box.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-qty-step]");
        if (!btn) return;
        var step = parseInt(btn.getAttribute("data-qty-step"), 10);
        /* Respect the input's own minimum: 1 on product forms, 0 in the
           cart, where stepping down to 0 removes the line on update. */
        var min = input.min !== "" ? parseInt(input.min, 10) : 1;
        input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });
  }

  /* ── Cart count ────────────────────────────────────────── */
  function setCartCount(n) {
    each("[data-cart-count]", function (el) {
      el.textContent = n;
      var link = el.closest(".cart-link");
      if (link && !reduced) {
        link.classList.remove("pop");
        void link.offsetWidth;
        link.classList.add("pop");
      }
    });
  }

  /* ── Product form: variants + AJAX add ─────────────────── */
  function initProductForm() {
    var root = document.querySelector("[data-product-root]");
    if (!root || !once(root, "Product")) return;

    var dataEl = root.querySelector("[data-product-json]");
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!product || !product.variants) return;

    /* The Liquid {% form %} tag can't take a hyphenated attribute, so the
       form is found by its action instead of a data- hook. */
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-price]");
    var compareEl = root.querySelector("[data-compare-price]");
    var unitEl = root.querySelector("[data-unit-price]");
    var submitBtn = root.querySelector("[data-add]");
    var stockline = root.querySelector("[data-stockline]");
    var stickyBtn = document.querySelector("[data-sticky-add]");
    var stickyLabel = document.querySelector("[data-sticky-label]");
    var current = null;

    function selectedOptions() {
      var values = [];
      each("[data-option-index]", function (group) {
        var checked = group.querySelector("input:checked");
        values[parseInt(group.getAttribute("data-option-index"), 10)] = checked ? checked.value : null;
      }, root);
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] === null || v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function renderUnitPrice() {
      if (!unitEl) return;
      var m = current && current.unit_price_measurement;
      unitEl.hidden = !m;
      if (!m) return;
      unitEl.textContent = str("unitPrice", "Unit price") + ": " + formatMoney(current.unit_price) + "/" +
        (m.reference_value !== 1 ? m.reference_value : "") + m.reference_unit;
    }

    function render() {
      var values = selectedOptions();
      var incomplete = values.some(function (v) { return v === null; });
      current = incomplete ? null : findVariant(values);

      if (idInput) idInput.value = current ? current.id : "";

      if (!current) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = incomplete
            ? (submitBtn.getAttribute("data-label-select") || "SELECT A SIZE")
            : (submitBtn.getAttribute("data-label-unavailable") || "UNAVAILABLE");
        }
        if (stickyBtn) stickyBtn.disabled = true;
        if (stockline) stockline.textContent = stockline.getAttribute("data-default") || "";
        renderUnitPrice();
        return;
      }

      if (priceEl) priceEl.textContent = formatMoney(current.price);
      if (compareEl) {
        var showCompare = current.compare_at_price && current.compare_at_price > current.price;
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = formatMoney(current.compare_at_price);
      }
      renderUnitPrice();

      var soldOut = !current.available;
      if (submitBtn) {
        if (submitBtn.disabled && !soldOut && !reduced) {
          submitBtn.classList.remove("swipe");
          void submitBtn.offsetWidth;
          submitBtn.classList.add("swipe");
        }
        submitBtn.disabled = soldOut;
        submitBtn.textContent = soldOut
          ? (submitBtn.getAttribute("data-label-soldout") || "SOLD OUT")
          : (submitBtn.getAttribute("data-label-add") || "ADD TO ARCHIVE") + " · " + formatMoney(current.price);
      }
      if (stickyBtn) stickyBtn.disabled = soldOut;
      if (stickyLabel) stickyLabel.textContent = formatMoney(current.price) + " · " + current.title;

      if (stockline) {
        if (soldOut) {
          stockline.innerHTML = str("stockSoldOut", "<b>Sold out</b> in this size.");
        } else if (current.inventory_management && current.inventory_quantity > 0 && current.inventory_quantity <= 20) {
          stockline.innerHTML = str("stockLow", "<b>Fewer than [quantity] units left</b> in this size.")
            .replace("[quantity]", current.inventory_quantity);
        } else {
          stockline.textContent = str("stockAvailable", "[variant] available in this run.")
            .replace("[variant]", current.title);
        }
      }

      if (history.replaceState && !designMode) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", current.id);
        history.replaceState({}, "", url.toString());
      }
    }

    each("[data-option-index] input", function (input) {
      input.addEventListener("change", render);
    }, root);

    /* AJAX add — falls back to a normal form POST if fetch fails */
    if (form) {
      form.addEventListener("submit", function (e) {
        if (!window.fetch || !current) return;
        e.preventDefault();
        var original = submitBtn ? submitBtn.textContent : "";
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = str("adding", "ADDING…"); }

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
        var qtyInput = form.querySelector("[name=quantity]");

        fetch(root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: current.id, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
          .then(function () { return fetch(root + "cart.js").then(function (r) { return r.json(); }); })
          .then(function (cart) {
            setCartCount(cart.item_count);
            if (submitBtn) {
              submitBtn.textContent = str("added", "ADDED") + " · " + current.title;
              setTimeout(function () { submitBtn.disabled = false; render(); }, 1600);
            }
          })
          .catch(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = original; }
            form.submit();
          });
      });
    }

    if (stickyBtn && form) {
      stickyBtn.addEventListener("click", function () {
        if (submitBtn) submitBtn.click();
      });
    }

    render();
  }

  /* ── Sticky buy bar ────────────────────────────────────── */
  function initStickyBar() {
    var bar = document.querySelector("[data-sticky-bar]");
    var anchor = document.querySelector("[data-sticky-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window) || !once(bar, "Sticky")) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle("on", entries[0].isIntersecting);
    }, { rootMargin: "-140px 0px -120px 0px" }).observe(anchor);
  }

  /* ── Filters: submit on change, one open panel at a time ─ */
  function initFacets() {
    each("[data-facets]", function (form) {
      if (!once(form, "Facets")) return;

      /* Empty price fields would send "filter.v.price.gte=" — drop them. */
      function strip() {
        each("input[type=number]", function (input) {
          if (input.value === "") input.disabled = true;
        }, form);
      }

      form.addEventListener("submit", strip);
      form.addEventListener("change", function (e) {
        if (e.target.matches("input[type=checkbox], select")) {
          strip();
          form.submit();
        }
      });

      each("details", function (group) {
        group.addEventListener("toggle", function () {
          if (!group.open) return;
          each("details[open]", function (other) {
            if (other !== group) other.open = false;
          }, form);
        });
      }, form);
    });
  }

  /* ── Signup forms (client-side validation only) ────────── */
  function initSignupValidation() {
    /* Found via the status element, because {% form %} can't take a hyphenated attribute */
    each("[data-signup-msg]", function (msg) {
      var form = msg.closest("form");
      if (!form || !once(form, "Signup")) return;
      form.addEventListener("submit", function (e) {
        var mail = form.querySelector("input[type=email]");
        var consent = form.querySelector("input[type=checkbox]");
        function fail(text, el) {
          e.preventDefault();
          msg.classList.add("formmsg--error");
          msg.textContent = text;
          if (el) el.focus();
        }
        if (!mail || !mail.value || mail.value.indexOf("@") < 1) return fail(str("invalidEmail", "Enter a valid email address."), mail);
        if (consent && !consent.checked) return fail(str("consentRequired", "Tick the consent box to join."), consent);
        msg.classList.remove("formmsg--error");
        msg.textContent = str("sending", "Sending…");
      });
    });
  }

  /* ── Password page: fold / unfold the key field ───────── */
  function initPasswordGate() {
    each(".pwgate", function (gate) {
      var toggle = gate.querySelector("[data-pw-toggle]");
      if (!toggle || !once(gate, "Pw")) return;
      var input = gate.querySelector("input[type=password]");
      /* Arrived on /password#enter, or Shopify sent back a wrong password */
      if (location.hash === "#enter" || gate.querySelector(".notice--error")) gate.classList.add("is-open");
      toggle.setAttribute("aria-expanded", String(gate.classList.contains("is-open")));
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        var open = gate.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", String(open));
        /* A leftover #enter would keep the panel open through :target */
        if (!open && location.hash === "#enter" && history.replaceState) {
          history.replaceState(null, "", location.pathname + location.search);
        }
        if (open && input) setTimeout(function () { input.focus(); }, 60);
      });
    });
  }

  /* ── Boot ──────────────────────────────────────────────── */
  function boot() {
    initHeadlineFit();
    initCountdown();
    initReveal();
    initPageTransitions();
    initHeaderScroll();
    initAccordions();
    initTables();
    initParallax();
    initNav();
    initQty();
    initProductForm();
    initStickyBar();
    initFacets();
    initSignupValidation();
    initPasswordGate();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Re-run when the theme editor swaps a section in */
  document.addEventListener("shopify:section:load", boot);
})();
